<template>
  <!-- eslint-disable max-len vue/max-len -->
  <a
    href="https://schooluniversity.ru/skidki?utm_source=SiteBanner&utm_medium=site&utm_campaign=202508042&utm_term=%D0%B1%D0%B0%D0%BD%D0%BD%D0%B5%D1%80_%D0%B3%D0%BB%D0%B0%D0%B2%D0%BD%D0%B0%D1%8F&marketer=dvk&produkt=67018269&utm_gen=3 "
    class="bottom-banner"
    @click.stop
  >
    <!-- eslint-enable -->
    <div class="bottom-banner__content">
      <h5 class="bottom-banner__left">
        август решает
        <span>выгода до 70 000 ₽</span>
      </h5>

      <button class="bottom-banner__btn m-btn">
        забрать подарки
      </button>

      <div class="bottom-banner__right ">
        <span>скидки до 60%</span>
        <span>курсы в подарок</span>
      </div>
    </div>
  </a>
</template>

<script>
// import getRemainingTime from '@/utils/remainingTime';

export default {
  name: 'BottomBanner',
  data: () => ({
    // remainingTime: {},
    // timer: null,
    // targetDate: new Date('2025-03-13T00:00:00'),
  }),
  computed: {
    /**
     * когда нужно с периодичностью обновляемая дата
     * @returns {Date}
     */
    // targetDate() {
    //   const today = new Date();
    //
    //   const oddDate = Boolean(today.getDate() % 2);
    //
    //   const tomorrow = new Date(today);
    //   tomorrow.setDate(today.getDate() + (oddDate ? 1 : 2));
    //   tomorrow.setHours(0, 0, 0, 0);
    //
    //   return tomorrow;
    // },
    // countdown() {
    //   return [
    //     {
    //       value: this.remainingTime.days || '00',
    //       text: this.getDeclension(this.remainingTime.days, ['День', 'Дня', 'Дней']),
    //     },
    //     {
    //       value: this.remainingTime.hours || '00',
    //       text: this.getDeclension(this.remainingTime.hours, ['Час', 'Часа', 'Часов']),
    //     },
    //     {
    //       value: this.remainingTime.minutes || '00',
    //       text: this.getDeclension(this.remainingTime.minutes, ['Минута', 'Минуты', 'Минут']),
    //     },
    //     {
    //       value: this.remainingTime.seconds || '00',
    //       text: this.getDeclension(this.remainingTime.seconds, ['Секунда', 'Секунды', 'Секунд']),
    //     },
    //   ];
    // },
  },
  beforeMount() {
    // this.remainingTime = getRemainingTime(this.targetDate);
    //
    // this.timer = setInterval(() => {
    //   this.remainingTime = getRemainingTime(this.targetDate);
    // }, 1000);
  },
  beforeDestroy() {
    // clearInterval(this.timer);
  },
  methods: {
    // getDeclension(number, words) {
    //   const cases = [2, 0, 1, 1, 1, 2];
    //   return words[
    //     number % 100 > 4 && number % 100 < 20
    //       ? 2
    //       : cases[number % 10 < 5 ? number % 10 : 5]
    //   ];
    // },
  },
};
</script>

<style lang="scss" scoped>
.bottom-banner {
  display: block;
  position: relative;
  height: calc(var(--scale) * 60);
  background-image: url("/v2/global/banner-bg.webp");
  background-position: center;
  background-size: cover;
  overflow: hidden;

  @include media-down($size-tablet) {
    background-image: url("/v2/global/banner-bg-tablet.webp");
    height: calc(var(--scale) * 50);
  }

  @include media-down($size-mobile) {
    background-image: url("/v2/global/banner-bg-mob.webp");
  }

  * {
    font-family: 'Onest', sans-serif;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    @include media-down($size-mobile) {
      justify-content: space-between;
      padding-inline: 16px;
    }
  }

  &__left {
    position: relative;

    font-weight: 700;
    font-size: 16px;
    line-height: 98%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      font-size: 13px;
    }

    @include media-down($size-mobile) {}

    span {
      display: block;
      margin-top: 3px;
      padding: 4px 5px;
      background-color: #FFF0D1;
      border-radius: 8px;

      font-weight: 600;
      line-height: 98%;
      color: #FF5319;

      @include media-down($size-mobile) {}
    }
  }

  &__btn {
    margin-inline: 30px;
    padding: 8px 20px 10px;
    background-color: #FF5319;
    border-radius: 16px;

    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      margin-inline: 19px 14px;
      padding: 7px 21px;
      border-radius: 8px;
      font-weight: 700;
      font-size: 11px;
      line-height: 120%;
    }

    @include media-down($size-mobile) {
      display: none;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    span {
      position: relative;
      padding: 4px 8px;
      border-radius: 999px;
      font-weight: 600;
      font-size: 16px;
      line-height: 98%;

      @include media-down($size-tablet) {
        padding: 3px 8px;
        font-size: 13px;
      }

      &:first-child {
        z-index: 2;
        background-color: #FFF0D1;
        color: #FF5319;

        @include media-down($size-tablet) {
          transform: rotate(-2.54deg);
        }
      }

      &:last-child {
        margin-left: 6px;
        background-color: #E6CEFF;
        transform: rotate(-2deg);
        color: #5237E6;

        @include media-down($size-tablet) {
          z-index: 3;
          transform: none;
          margin-left: -8px;
          margin-top: -2px;
        }
      }
    }
  }
}
</style>
